import React from 'react';

const bundledAvatars = require.context(
  '../../../../assets/avatares',
  false,
  /\.(JPG|JPEG|PNG)$/i
);

const avatarMap = bundledAvatars.keys().reduce((result, key) => {
  result[key.replace('./', '')] = bundledAvatars(key);
  return result;
}, {});

const resolveAvatar = (avatar) => {
  if (!avatar) return '/logo192.png';
  if (avatarMap[avatar]) return avatarMap[avatar];
  if (/^(https?:|data:|blob:|\/)/i.test(avatar)) return avatar;
  return '/logo192.png';
};

function NewAvatar({ avatar, alt = '', className = '' }) {
  return (
    <img
      className={className}
      src={resolveAvatar(avatar)}
      alt={alt}
      onError={(event) => {
        if (!event.currentTarget.src.endsWith('/logo192.png')) {
          event.currentTarget.src = '/logo192.png';
        }
      }}
    />
  );
}

export default React.memo(NewAvatar);
